import { render, staticRenderFns } from "./NewChat.vue?vue&type=template&id=18fc639a"
import script from "./NewChat.vue?vue&type=script&lang=js"
export * from "./NewChat.vue?vue&type=script&lang=js"
import style0 from "./NewChat.vue?vue&type=style&index=0&id=18fc639a&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports